const state = {
  // 预订单信息
  preOrderInfo: {
    validPlatformCoupons: [],
    invalidPlatformCoupons: []
  },
  // 商品清单页展示的信息（预订单页/订单详情页进入）
  showOrderList: [],
  // 点击跳转随货资质的店铺维度信息
  certificationMerchantItemInfos: {
    followGoodsCertification: []
  },
  // 订单详情
  orderInfo: {}
};

const getters = {};

const mutations = {
  SET_PRE_ORDER_INFO(state, data) {
    state.preOrderInfo = data;
  },
  SET_SHOW_ORDER_LIST(state, data) {
    state.showOrderList = data;
  },
  SET_CERIFICATION_MERCHANT_INFOS(state, data) {
    state.certificationMerchantItemInfos = data;
  },
  SET_ORDER_INFO(state, data) {
    state.orderInfo = data;
  }
};

const actions = {
  setPreOrderInfo({ commit }, data) {
    commit('SET_PRE_ORDER_INFO', data);
  },
  setShowOrderList({ commit }, data) {
    commit('SET_SHOW_ORDER_LIST', data);
  },
  setCertificationMerchantItemInfos({ commit }, data) {
    commit('SET_CERIFICATION_MERCHANT_INFOS', data);
  },
  setOrderInfo({ commit }, data) {
    commit('SET_ORDER_INFO', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
